export default "__VITE_ASSET__1SH_3pIjoy69NhNnABNVtA__"